var $ef61835e85beb693$exports = {};
// Responsive layout of Blog Image and meta info
document.addEventListener('DOMContentLoaded', function() {
    const container = document.getElementById('subhero-container');
    if (!container) return;
    const textBlock = container.querySelector('.subhero-text');
    const imageBlock = container.querySelector('.subhero-image');
    const title = textBlock.querySelector('.subhero-title');
    const meta = textBlock.querySelector('.subhero-meta');
    // ⛔ Exit if the title is "Sunny's Blog" (landing page)
    if (title && title.textContent.trim() === "Sunny's Blog") return;
    let currentLayout = null;
    function rearrangeLayout() {
        const isMobile = window.innerWidth < 640;
        if (isMobile && currentLayout !== 'mobile') {
            // Title above image
            container.insertBefore(title, imageBlock);
            // Meta below image
            container.appendChild(meta);
            currentLayout = 'mobile';
            console.log("\u2192 Mobile layout");
        }
        if (!isMobile && currentLayout !== 'desktop') {
            // Restore both into text block
            textBlock.appendChild(title);
            textBlock.appendChild(meta);
            currentLayout = 'desktop';
            console.log("\u2192 Desktop layout");
        }
    }
    rearrangeLayout(); // Initial run
    window.addEventListener('resize', rearrangeLayout); // Handle resizes
});


//# sourceMappingURL=blogs.js.map
